import { render, staticRenderFns } from "./marriageAdd.vue?vue&type=template&id=62c449cd&scoped=true"
import script from "./marriageAdd.vue?vue&type=script&lang=js"
export * from "./marriageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c449cd",
  null
  
)

export default component.exports